import React from "react";

const BreatheAnimation = () => {
  return (
    <>
      <style>
        {`
          @font-face {
            font-family: 'TheFont';
            src: url("https://garet.typeforward.com/assets/fonts/shared/TFMixVF.woff2") format('woff2');
          }

          .breathe-animation {
            font-size: 70px;
          }
          @media (max-width: 600px) {
            .breathe-animation {
              font-size: 40px;
            }
          }

          .breathe-animation h3 {
            font-family: 'TheFont';
            color: white;
            text-align: center;
            animation: letter-breathe 3s ease-in-out infinite;
          }
          .breathe-animation span {
            font-family: 'Degular';
            color: white;
            text-align: center;
            animation: letter-breathe 3s ease-in-out infinite;
          }

          @keyframes letter-breathe {
            from,
            to {
              font-variation-settings: 'wght' 100;
            }
            50% {
              font-variation-settings: 'wght' 900;
            }
          }
        `}
      </style>
      <div className="breathe-animation">
        <h3>mix <br/><span>imagination</span></h3>
      </div>
    </>
  );
};

export default BreatheAnimation;
